import React from 'react';
import { ErrorNotification, P } from '@ovotech/nebula';

export const IneligibleSection = () => (
  <ErrorNotification id="consent-ineligible-section">
    <P>You need an active smart meter to change these settings.</P>
  </ErrorNotification>
);
